import type { z } from 'zod';

import { typedZod4Resolver } from '@apple/ui/form/validation/typed-zod4-resolver';
import type { AllKeysAreStrings } from '@apple/utils/type';

import type { ValidatedFormProps } from './ValidatedForm';
import { ValidatedForm } from './ValidatedForm';

type Props<
	T extends AllKeysAreStrings<T>,
	TSchema extends z.ZodType,
	TTransformedValues = T,
> = Omit<ValidatedFormProps<T, TTransformedValues>, 'validate'> & {
	schema: TSchema;
	schemaExtension?: (schema: TSchema) => z.ZodType;
};

export function ValidatedZodForm<
	T extends AllKeysAreStrings<T>,
	TSchema extends z.ZodType,
	TTransformedValues = T,
>({ schema, schemaExtension, ...rest }: Props<T, TSchema, TTransformedValues>) {
	return (
		<ValidatedForm<T, TTransformedValues>
			{...rest}
			validate={typedZod4Resolver<T>(schemaExtension ? schemaExtension(schema) : schema)}
		/>
	);
}
